import * as React from "react";
import { styled } from "@mui/material";
import { LocationQuestionsMetaData } from "./locationQuestions/locationQuestionsIndex";
import { SvgLoader, SvgProxy } from "react-svgmt";
//region [[ Styles ]]

const LocationMapsFeatureCounterView = styled("div")({
  // Keep it not presented in dom. we just want to manipulate the content of our svg
  display: "none",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LocationMapsFeatureCounterProps {
  maps: LocationQuestionsMetaData[];
  onSupportedElementCount: (index: number, count: number) => void;
  /* list of ids the user can select */
  supportedFeatures: string[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
/****
 * This components uses the DOM to determine which maps contains clickable features and which not, not make sure we show
 * the user only maps where there are real features they can click on
 * @param props
 * @constructor
 */
export const LocationMapsFeatureCounter = ({
  supportedFeatures,
  ...props
}: LocationMapsFeatureCounterProps) => {
  const createElementSelectionHandler = (index) => (e) => {
    // console.log("createElementSelectionHandler", e);
    let count = 0;
    if (Array.isArray(e)) {
      e.forEach((mapFeature) => {
        const featureId = mapFeature.attributes?.["data-feature-id"]?.nodeValue;
        if (supportedFeatures?.some?.((f) => f === featureId)) {
          count++;
        }
      });
    }
    props?.onSupportedElementCount?.(index, count);
    console.log(
      `createElementSelectionHandler: supported features in ${props.maps[index].name} map:`,
      count,
    );
  };
  return (
    <LocationMapsFeatureCounterView>
      {props.maps.map((diagram, index) => (
        <SvgLoader path={diagram.component}>
          <SvgProxy
            selector={"path[data-feature-id]"}
            onElementSelected={createElementSelectionHandler(index)}
          />
        </SvgLoader>
      ))}
    </LocationMapsFeatureCounterView>
  );
};
